module.exports = __webpack_public_path__ + "img/54.cc59612d.jpg";